module.exports = __webpack_public_path__ + "static/img/Permiso(16).ebb4eaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(16).jpg
// module id = wXnS
// module chunks = 0